<template>
    <div style="max-width: 1500px; margin: 0 auto;">
        <b-row class="font-weight-bold mb-1 row-border">
                <b-col cols="4">DCC</b-col>
                <b-col cols="2">DCC Allows Discounts</b-col>
                <b-col cols="1" offset="2">Allow</b-col>
                <b-col cols="2">Discount %</b-col>
        </b-row>
        <b-card
            v-for="department in dccs"
            :key="department.dccDepartmentId"
            class="mb-1"
            no-body
        >
            <b-card-body class="p-1">
            <b-row class="department-row" @click="toggleActive(department, 'isActive', department)">
            <b-col cols="4">
                <b-button
                    v-b-toggle="
                        'departmentToggle_' + department.dccDepartmentId
                    "
                    class="short-button p-0"
                    @click.stop
                >
                    <b-icon-chevron-down class="when-open mb-1" font-scale=".9"></b-icon-chevron-down>
                    <b-icon-chevron-right class="when-closed mb-1" font-scale=".9"></b-icon-chevron-right>
                </b-button>
                <span
                    :class="{
                        'ps-1' : true,
                        'selectable-element': true,
                        'selected-element':
                            selectedDcc.department === department &&
                            selectedDcc.class === undefined,
                        'selected-parent':
                            selectedDcc.department === department &&
                            selectedDcc.class != undefined
                    }"
                    >{{ numberToString(department.number) }}
                    {{ department.name }}</span
                >
            </b-col>
            <b-col cols="2" @click.stop><span class="d-inline-block">
                <p-checkbox
                    :model-value="department.allowsDiscounts"
                    :disabled="true">
                </p-checkbox></span></b-col>
            <b-col cols="1" offset="2" @click.stop><span class="d-inline-block">
                <p-checkbox
                    v-model="department.isActive"
                    @change="combinedCategorySettingChange(department, 'isActive',department)">
                </p-checkbox></span></b-col>
            <b-col cols="2" @click.stop><span class="d-inline-block">
                    <p-number
                        name="Discount"
                        v-model.number="department.percentDiscount"
                        style=""
                        rules="min_value:0|max_value:100"
                        input-type="percent"
                        :disabled="!department.allowsDiscounts || !department.isActive"
                        @change="combinedCategorySettingChange(department,'percentDiscount',department)">
                    </p-number>
                </span>
            </b-col>
            </b-row>
                <b-collapse
                    :id="'departmentToggle_' + department.dccDepartmentId" visible
                >
                    <div
                        v-for="dccClass in department.dccClasses"
                        :key="dccClass.dccclassId"
                    >
                    <b-row class="class-row" @click="toggleActive(dccClass, 'isActive', department)">
                        <b-col cols="4" class="ps-4">
                            <b-button
                                v-b-toggle="'dccClassToggle_' + dccClass.dccClassId"
                                class="short-button p-0 "
                                @click.stop
                            >
                                <b-icon-chevron-down class="when-open mb-1" font-scale=".9"></b-icon-chevron-down>
                                <b-icon-chevron-right class="when-closed mb-1" font-scale=".9"></b-icon-chevron-right>

                            </b-button>
                            <span
                                :class="{
                                    'ps-1' : true,
                                    'selectable-element': true,
                                    'selected-element':
                                        selectedDcc.class === dccClass &&
                                        selectedDcc.category === undefined,

                                    'selected-parent':
                                        selectedDcc.class === dccClass &&
                                        selectedDcc.category != undefined
                                }"
                                >{{ numberToString(dccClass.number) }}
                                {{ dccClass.name }}
                            </span>
                        </b-col>
                        <b-col cols="2" @click.stop>
                            <span class="d-inline-block">
                                <p-checkbox
                                    :model-value="dccClass.allowsDiscounts"
                                    :disabled="true">
                                </p-checkbox>
                            </span>
                        </b-col>
                        <b-col cols="1" offset="2" @click.stop>
                            <span class="d-inline-block">
                                <p-checkbox
                                    v-model="dccClass.isActive"
                                    @change="combinedCategorySettingChange(dccClass, 'isActive',department)">
                                </p-checkbox>
                            </span>
                        </b-col>
                        <b-col cols="2" @click.stop>
                            <span class="d-inline-block">
                                <p-number
                                name="Discount"
                                v-model.number="dccClass.percentDiscount" 
                                rules="min_value:0|max_value:100"
                                input-type="percent"
                                :disabled="!dccClass.allowsDiscounts || !dccClass.isActive"
                                @change="combinedCategorySettingChange(dccClass,'percentDiscount',department)">
                                </p-number>
                            </span>
                        </b-col>
                    </b-row>
                    <b-collapse
                            :id="'dccClassToggle_' + dccClass.dccClassId" visible
                        >
                            <div
                                v-for="dccCategory in dccClass.dccCategories"
                                :key="dccCategory.dccCategoryId"
                            >
                            <b-row @click="toggleActive(dccCategory, 'isActive', department, dccClass)">
                                <b-col cols="4" class="ps-5">
                                    <span
                                        :class="{
                                            'selectable-element': true,
                                            'inactive-element': !dccCategory.isActive,
                                            'active-element': dccCategory.isActive,
                                            'selected-element':
                                                selectedDcc.category === dccCategory
                                        }"
                                        @click="
                                            selectedElement(
                                                department,
                                                dccClass,
                                                dccCategory
                                            )
                                        "
                                        >{{ numberToString(dccCategory.number) }}
                                        {{ dccCategory.name }}</span
                                    >
                                </b-col>
                                <b-col cols="2" @click.stop>
                                    <span class="d-inline-block">
                                        <p-checkbox
                                            :model-value="dccCategory.allowsDiscounts"
                                            :disabled="true">
                                        </p-checkbox>
                                    </span>
                                </b-col>
                                <b-col cols="1" offset="2" @click.stop>
                                    <span class="d-inline-block">
                                        <p-checkbox
                                            v-model="dccCategory.isActive"
                                            @change="combinedCategorySettingChange(dccCategory, 'isActive',department, dccClass)">
                                        </p-checkbox>
                                    </span>
                                </b-col>
                                <b-col cols="2" @click.stop>
                                    <span class="d-inline-block">
                                        <p-number
                                        name="Discount" 
                                        v-model.number="dccCategory.percentDiscount" 
                                        rules="min_value:0|max_value:100"
                                        input-type="percent"
                                        :disabled="!dccCategory.allowsDiscounts || !dccCategory.isActive"
                                        @change="combinedCategorySettingChange(dccCategory,'percentDiscount',department, dccClass)">
                                        </p-number>
                                    </span>
                                </b-col>
                        </b-row>
                            </div> 
                        </b-collapse>
                    </div>
                </b-collapse>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
export default {
    name: "dcc-list",
    props: {
        dccs: [Array],
        selectedDcc: [Array]
    },
    data() {
        return {};
    },
    watch: {},
    computed: {
        updatedDepartment() {
            return this.dccs[0];
        },
        updatedCategory() {
            return this.dccs.find(x => x.dccLevel === "Department");
        },
        updatedClass() {
            return this.dccs.find(x => x.dccLevel === "Class");
        }
    },
    methods: {
        toggleActive(element, prop, department, dccClass) {
            element.isActive = !element.isActive;
            this.combinedCategorySettingChange(element, prop, department, dccClass);
        },
        numberToString(number) {
            return number.toLocaleString("en-US", {
                minimumIntegerDigits: 2,
                useGrouping: false
            });
        },
        combinedCategorySettingChange(element, updatedPropertyName, department, dccClass){
            this.$nextTick(() => {
                let newValue = element[updatedPropertyName];
                if(element.dccLevel === "Department"){
                    this.setPropertyRecursivelyDepartmentClick(element,newValue,'dccClasses',updatedPropertyName,department);
                }
                else if(element.dccLevel === "Class"){
                    this.setPropertyRecursivelyClassClick(element,newValue,'dccCategories',updatedPropertyName,department);
                    //added for traversing that parent should be null if childs have diffrent property values.
                    if(!department['dccClasses'].every(ele => ele[updatedPropertyName] === newValue) || department[updatedPropertyName] != newValue){
                        department[updatedPropertyName] = null;
                    }
                    if(department.dccClasses.every(ele => ele[updatedPropertyName] === newValue))department[updatedPropertyName]=newValue
                }
                else if(element.dccLevel === "Category"){
                    if(!department.dccClasses.find(x => x.dccClassId == dccClass.dccClassId)['dccCategories'].every(ele => ele[updatedPropertyName] === newValue) 
                            || department.dccClasses.find(x => x.dccClassId == dccClass.dccClassId)[updatedPropertyName] != newValue){
                        department.dccClasses.map((ele)=> {
                            if(element['dccClassId'] === ele['dccClassId']){
                                ele.dccCategories.length == 1 ? ele[updatedPropertyName] = newValue : ele[updatedPropertyName] = null;
                            }
                        });
                        department[updatedPropertyName] = null;
                    }else{
                        department.dccClasses.map((ele)=> {
                            if(element['dccClassId'] === ele['dccClassId']){
                                ele.dccCategories.length == 1 ? ele[updatedPropertyName] = newValue : ele[updatedPropertyName] = null;
                            }
                        }); 
                    }

                    department.dccClasses.map((elem)=>{
                        if(elem.dccCategories.every(ele => ele[updatedPropertyName] === newValue))elem[updatedPropertyName]=newValue;
                    })
                    if(department.dccClasses.every(ele => ele[updatedPropertyName] === newValue))department[updatedPropertyName]=newValue
                }
            });
        },
        setPropertyRecursivelyDepartmentClick(element,newValue,iterableElements,updatedPropertyName) {
            element[iterableElements].map((ele)=> {
                ele[updatedPropertyName] = newValue;
                this.setPropertyRecursivelyClassClick(ele,newValue,'dccCategories',updatedPropertyName);
                return ele;
            });
        },
        setPropertyRecursivelyClassClick(element,newValue,iterableElements,updatedPropertyName) {
            element[iterableElements].map((ele)=> {
                ele[updatedPropertyName] = newValue;
                return ele;
            });
        }
    },

};
</script>
<style scoped lang="scss">
@import "@/styles/app/common/variables.scss";
:deep(.selected-element ) {
    background-color: $gray-lighter;
    outline-style: solid;
    outline-width: 1px;
    padding: 2px;
    outline-color: $gray;
}
:deep(.collapsed > .when-open), :deep(.not-collapsed > .when-closed) {
    display: none;
}
:deep(.short-button ) {
    height: 25px;
    background-color: inherit;
    border: none;
}
:deep(.selectable-element ) {
    cursor: pointer;
    width: 100%;
}
:deep(.selected-parent ) {
    text-decoration: underline;
}
:deep(.inactive-element ) {
    opacity: .8;
}
.row-border{
    border-color: transparent;
    -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}
:deep(.form-check-input) {
    width: 1.4em;
    height: 1.4em;
    margin-top: 0.1em;
    cursor: pointer;
}
:deep(.row) {
    --bs-gutter-x: 0.5rem;
}
.department-row {
    background-color: $gray-lighter;
}
.class-row {
    background-color: #f5f7fa;
}
:deep(.row:hover) {
    background-color: #e9ecef;
}
:deep(.row) {
    align-items: center;
}
</style>
